// import React from "react";
// import ListView from "../../../site/list";
// import { listApi, newRecord, tableFields, uriBasePath } from "./module";

// function WorkTypeList() {
//   return (
//     <div className="list-container">
//       <ListView
//         listApi={listApi}
//         listHeading={"Work Type List"}
//         tableFields={tableFields}
//         newRecord={newRecord}
//         uriBasePath={uriBasePath}
//       />
//     </div>
//   );
// }

// export default WorkTypeList;


import React from "react";
import ListView from "../../../site/list";
import { listApi, newRecord, tableFields, uriBasePath } from "./module";

function WorkTypeList() {
  return (
    <div className="list-container">
      <ListView
        listApi={listApi}
        listHeading={"Work Type List"}
        tableFields={tableFields}
        newRecord={newRecord}
        uriBasePath={uriBasePath}
      />
    </div>
  );
}

export default WorkTypeList;